module.exports = __webpack_public_path__ + "img/2.9ff5f5c6.jpg";